import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { CartlessConfirmationPage } from '../../../ui-permit/src/containers/CartlessConfirmationPage';


export class CartlessConfirmationPageHOC extends React.Component {

  render() {
    return (
      <CartlessConfirmationPage {...this.props} />
    );
  }
}

CartlessConfirmationPageHOC.propTypes = {
  confirmation: PropTypes.object.isRequired
};

CartlessConfirmationPageHOC.defaultProps = {
  confirmation: {}
};

function select(state) {
  return {
    confirmation: state.inyonwhitney.permit.order_confirmation
  };
}

export default connect(select)(CartlessConfirmationPageHOC);
